<div class="filter" [class.filter-sidebar]="!isMobile()">
  @if (!isMobile()) {
    <div class="filter-title">
      <i nz-icon nzType="icons:filter" class="svg-icon"></i>
      <h4>{{ i18n.langString("filter_plural") }}</h4>
      @if (isFiltered()) {
        <button
          class="clear-btn"
          aria-label="Clear Filter"
          (click)="clearFilter()"
        >
          <i nz-icon nzType="icons:exit" class="svg-icon"></i>
          <span class="body-bold">{{ i18n.langString("clear_filter") }}</span>
        </button>
      }
    </div>
  }

  <div class="filter-inner-content">
    @if (cfg.appName === "em") {
      <!-- Status  -->
      <div class="select-container">
        <label for="status" class="body-bold select-label">{{
          i18n.langString("status")
        }}</label>
        <div class="select-inner-container">
          <app-safe-select
            [options]="statusOptions()"
            [value]="status()"
            [selectedClass]="status() > 0"
            [iconClass]="'fillblackcoral'"
            (valueChange)="setStatus($event)"
          ></app-safe-select>
        </div>
      </div>
      <br /><br />
    }
    <!-- Equipment Type -->
    <div class="select-container">
      <label class="body-bold">{{ i18n.langString("equipment_type") }}</label>
      @if (filteredAssets()) {
        <div class="asset-type-container">
          @if (hasFlanges) {
            <button
              class="assets"
              [class.active]="filter().Flange"
              (click)="toggleFilterFlag('Flange')"
            >
              <i
                nz-icon
                nzType="icons:flange"
                class="svg-icon filter-icon"
                [class.fillwhite]="filter().Flange"
              ></i>
              <p class="icon-text">{{ i18n.langString("flange") }}</p>
              @if (!filter().Flange) {
                <i
                  nz-icon
                  nzType="icons:checkbox-empty"
                  class="svg-icon filter-check-icon"
                ></i>
              } @else {
                <i
                  nz-icon
                  nzType="icons:status-check"
                  class="svg-icon filter-check-icon fillwhite"
                ></i>
              }
            </button>
          }
          @if (hasTanks) {
            <button
              class="assets"
              [class.active]="filter().Tank"
              (click)="toggleFilterFlag('Tank')"
            >
              <i
                nz-icon
                nzType="icons:tank"
                class="svg-icon tank-icon"
                [class.fillwhite]="filter().Tank"
              ></i>
              <p class="icon-text">{{ i18n.langString("tank") }}</p>
              @if (!filter().Tank) {
                <i
                  nz-icon
                  nzType="icons:checkbox-empty"
                  class="svg-icon filter-check-icon"
                ></i>
              } @else {
                <i
                  nz-icon
                  nzType="icons:status-check"
                  class="svg-icon filter-check-icon fillwhite"
                ></i>
              }
            </button>
          }
          @if (hasPipes) {
            <button
              class="assets"
              [class.active]="filter().Pipe"
              (click)="toggleFilterFlag('Pipe')"
            >
              <i
                nz-icon
                nzType="icons:pipe"
                class="svg-icon pipe-icon"
                [class.fillwhite]="filter().Pipe"
              ></i>
              <p class="icon-text">{{ i18n.langString("pipe") }}</p>
              @if (!filter().Pipe) {
                <i
                  nz-icon
                  nzType="icons:checkbox-empty"
                  class="svg-icon filter-check-icon"
                ></i>
              } @else {
                <i
                  nz-icon
                  nzType="icons:status-check"
                  class="svg-icon filter-check-icon fillwhite"
                ></i>
              }
            </button>
          }
          @if (hasValves) {
            <button
              class="assets"
              [class.active]="filter().Valve"
              (click)="toggleFilterFlag('Valve')"
            >
              <i
                nz-icon
                nzType="icons:valve"
                class="svg-icon valve-icon"
                [class.fillwhite]="filter().Valve"
              ></i>
              <p class="icon-text">{{ i18n.langString("valve") }}</p>
              @if (!filter().Valve) {
                <i
                  nz-icon
                  nzType="icons:checkbox-empty"
                  class="svg-icon filter-check-icon"
                ></i>
              } @else {
                <i
                  nz-icon
                  nzType="icons:status-check"
                  class="svg-icon filter-check-icon fillwhite"
                ></i>
              }
            </button>
          }
          @if (hasSteamTraps) {
            <button
              class="assets"
              [class.active]="filter().SteamTrap"
              (click)="toggleFilterFlag('SteamTrap')"
            >
              <i
                nz-icon
                nzType="icons:steamtrap"
                class="svg-icon steamtrap-icon"
                [class.fillwhite]="filter().SteamTrap"
              ></i>
              <p class="icon-text">{{ i18n.langString("steamtrap") }}</p>
              @if (!filter().SteamTrap) {
                <i
                  nz-icon
                  nzType="icons:checkbox-empty"
                  class="svg-icon filter-check-icon"
                ></i>
              } @else {
                <i
                  nz-icon
                  nzType="icons:status-check"
                  class="svg-icon filter-check-icon fillwhite"
                ></i>
              }
            </button>
          }
          @if (hasRotatingEquipment) {
            <button
              class="assets"
              [class.active]="filter().RotatingEquipment"
              (click)="toggleFilterFlag('RotatingEquipment')"
            >
              <i
                nz-icon
                nzType="icons:rotatingEqu"
                class="svg-icon rotatingEqu-icon"
                [class.fillwhite]="filter().RotatingEquipment"
              ></i>
              <p class="icon-text">{{ i18n.langString("rotatingEqu") }}</p>
              @if (!filter().RotatingEquipment) {
                <i
                  nz-icon
                  nzType="icons:checkbox-empty"
                  class="svg-icon filter-check-icon"
                ></i>
              } @else {
                <i
                  nz-icon
                  nzType="icons:status-check"
                  class="svg-icon filter-check-icon fillwhite"
                ></i>
              }
            </button>
          }
        </div>
      }
    </div>

    <!-- Customer Filter -->
    @if (isSuperUser() && !plantsFilter()) {
      <div class="select-container customer">
        <label class="body-bold select-label">{{
          i18n.langString("customer")
        }}</label>
        <app-safe-select
          [options]="customerOptions()"
          [value]="customer()"
          [selectedClass]="customer() !== 'null'"
          [disabled]="customerSelectDisabled()"
          [compareWith]="fnCustomerCompare"
          [iconClass]="'fillblackcoral'"
          (valueChange)="setCustomer($event)"
        ></app-safe-select>
      </div>
      <br /><br />
    }

    <!-- Location Filter -->
    <div class="select-container location">
      <label class="body-bold select-label">{{
        i18n.langString("location")
      }}</label>
      @if (selectionPreset().length > 0) {
        <app-breadcrumbs
          [array]="selectionPreset()"
          [bold]="false"
        ></app-breadcrumbs>
      }
      @for (selection of filterSelections(); track selection.index) {
        @if (selection.name !== "Equipment") {
          <app-safe-select
            [options]="locationOptionsFor(selection)"
            [value]="selection.selected"
            [selectedClass]="selection.selected !== empty()"
            [disabled]="selection.disabled"
            [compareWith]="fnLocationCompare"
            (valueChange)="setLocation(selection.index, $event)"
          ></app-safe-select>
        }
      }
    </div>
    <br /><br />
  </div>

  <!-- Footer -->
  <div class="footer">
    <app-nav-button
      class="filter-button drop-shadow body-bold"
      (clickEvent)="onSubmit()"
      [primary]="true"
      [class.active-filter]="AssetCount() > 0"
    >
      @if (AssetCount() > 0 && filterCount() > 0) {
        <nz-badge
          [nzCount]="AssetCount()"
          nzStandalone
          [nzStyle]="{ backgroundColor: 'white', color: '#5F6973' }"
        ></nz-badge>
      }
      <span>{{ i18n.langString("show_results") }}</span>
    </app-nav-button>
    @if (isMobile()) {
      <button (click)="clearFilter()">
        {{ i18n.langString("clear_filter") }}
      </button>
    }
  </div>
</div>
